"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RelationshipsApi = void 0;
var _endpointHelpers = require("../util/endpointHelpers");
var _queryClientUtils = require("../util/queryClientUtils");
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
const relationshipsOrigin = () => {
  const env = (0, _acsScWebPlatformApi.getEnv)();
  switch (env) {
    case _acsScWebPlatformApi.ENVS.PRODUCTION:
      return "https://developer.api.autodesk.com/bim360/relationship/v2";
    case _acsScWebPlatformApi.ENVS.STAGING:
      return "https://developer-stg.api.autodesk.com/bim360/relationship/v2";
    case _acsScWebPlatformApi.ENVS.QA:
      return "https://developer-stg.api.autodesk.com/bim360/relationship-dev/v2";
    default:
      throw new Error("Using relationships origin outside of supported envs");
  }
};
const RelationshipsApi = exports.RelationshipsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: _ref2 => {
      let {
        issueId,
        onlyDeleted,
        deletedAfter
      } = _ref2;
      return api.create("relationships:intersect?".concat(createSearchParams({
        onlyDeleted,
        deletedAfter
      })), {
        entities: [{
          id: issueId,
          type: "issue",
          domain: "autodesk-bim360-issue"
        }]
      });
    }
  };
}, {
  origin: relationshipsOrigin(),
  projectsKeyword: "containers",
  // no queries to invalidate (only mutation)
  invalidateByQueryKeys: () => _queryClientUtils.NO_QUERIES_TO_INVALIDATE
});
const createSearchParams = _ref3 => {
  let {
    onlyDeleted,
    deletedAfter
  } = _ref3;
  const searchParams = new URLSearchParams();
  if (onlyDeleted) {
    searchParams.set("onlyDeleted", "true");
    searchParams.set("includeDeleted", "true");
    searchParams.set("deletedAfter", deletedAfter);
  }
  return searchParams;
};
//# sourceMappingURL=RelationshipsApi.js.map